import { getQueryArgs } from '../core/utils';
import { useBaseQuery } from './useBaseQuery'; // TYPES

// Implementation
export function useQuery() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _getQueryArgs = getQueryArgs(args),
      queryKey = _getQueryArgs[0],
      config = _getQueryArgs[1];

  return useBaseQuery(queryKey, config);
}